import FastRewindIcon from "@mui/icons-material/FastRewind";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Loader from "components/Loader";
import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Link, useParams } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
// import { useCourse } from 'hooks/useCourse';
// import CourseContext from 'contexts/CourseContext';
import axios from "config/axios";
import { useAuth } from "hooks/useAuth";
import { toast } from "react-toastify";
import SectionCard from "./SectionCard";
import "./createSection.css"




const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

// const modules = {
//   toolbar: [
//     [{ header: "1" }, { header: "2" }, { header: "3" }],
//     ["bold", "italic", "underline", "strike"],
//     [{ list: "ordered" }, { list: "bullet" }],
//     ["link", "image"],
//     ["clean"],
//   ],
// };

// const formats = [
//   "header",
//   "bold",
//   "italic",
//   "underline",
//   "strike",
//   "list",
//   "bullet",
//   "link",
//   "image",
// ];


const formats = [
  // Include all desired formatting options here
  "bold",
  "italic",
  "underline",
  "strike",
  "script",
  "subscript",
  "superscript",
  "blockquote",
  "code-block",
  "header",
  "list",
  "bullet",
  "indent",
  "outdent",
  "link",
  "image",
  "formula",
  "color",
  "background",
  "align",
  "direction",
  "code",
  "clean", // Keep 'clean' for basic formatting removal
];

const modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { header: "3" }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }], // Indentation control
    [{ align: [] }], // Text alignment (left, center, right, justify)
    ["link", "image", "formula"], // Formula editor (if desired)
    ["color", { color: [] }], // Custom color picker
    ["background", { color: [] }], // Custom background color picker
    ["clean"], // Basic formatting removal
  ],
};

export default function CreateSection({ url }) {
  // const {createCourse} = useCourse();
  // const {createCourse} = useContext(CourseContext);
  const { getSectionsofModule, createSection } = useAuth();
  const { courseId, moduleId } = useParams();

  const [sectionCreateModalOpen, setSectionCreateModalOpen] =
    React.useState(false);
  const [sections, setSections] = useState(null);
  const [isNewSectionCreated, setIsNewSectionCreated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [sectionDeleteModalOpen, setSectionDeleteModalOpen] =
    React.useState(false);
  const [isSectionDeleted, setIsSectionDeleted] = useState(false);
  const [selectedSectionId, setSelectedSectionId] = useState(null);
  const [isSectionsOrderUpdated, setIsSectionsOrderUpdated] = useState(false);

  const [sectionData, setSectionData] = useState({
    title: "",
    description: "",
    videoUrl: "",
    pdfs: [],
  });


  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Initial check
    const checkIsMobile = () => setIsMobile(window.innerWidth < 640); // Tailwind's sm breakpoint

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSectionData({
      ...sectionData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    setSectionData({
      ...sectionData,
      pdfs: [...sectionData.pdfs, ...files],
    });
  };

  const handleRemovePDF = (index) => {
    const updatedPdfs = sectionData.pdfs.filter((_, i) => i !== index);
    setSectionData({
      ...sectionData,
      pdfs: updatedPdfs,
    });
  };

  const moveSection = (result) => {
    if (!result.destination) {
      return;
    }
    const updatedSections = Array.from(sections);
    const [movedSection] = updatedSections.splice(result.source.index, 1);
    updatedSections.splice(result.destination.index, 0, movedSection);
    setSections(updatedSections);
    // console.log(updatedModules);
  };

  const handleUpdateSectionsOrder = async () => {
    const updatedSectionsOrder = sections.map((section, index) => ({
      sectionId: section._id,
      order: index + 1,
    }));
    console.log(updatedSectionsOrder);

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/courses/section/updateSectionsOrder/${moduleId}`,
        { sectionsOrder: updatedSectionsOrder }
      );

      if (response.data.success) {
        toast.success("Sections order updated successfully");
        // console.log("Modules order updated successfully");
        // console.log(response.data.modules);
        setIsSectionsOrderUpdated(!isSectionsOrderUpdated);
      } else {
        toast.error("Failed to update sections order");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update sections order 2");
    }
  };

  const handleDeleteButtonClick = (sectionId) => {
    setSectionDeleteModalOpen(true);
    setSelectedSectionId(sectionId);
  };

  const handleSectionDelete = async () => {
    const response = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/api/courses/section/${selectedSectionId}`
    );
    setSectionDeleteModalOpen(false);
    setIsSectionDeleted(!isSectionDeleted);
    toast.success("Section successfully deleted");
  };

  const fetch = async () => {
    setIsLoading(true);
    const response = await getSectionsofModule(moduleId);
    if (response.success) {
      const sortedSections = response.sections.sort(
        (a, b) => a.order - b.order
      );
      setSections(sortedSections);
    }
    setIsLoading(false);
  };

  function convertYouTubeLink(link) {
    const url = new URL(link);
    let videoId = url.pathname.substr(1);
    const paramIndex = videoId.indexOf("?");
    if (paramIndex !== -1) {
      videoId = videoId.substring(0, paramIndex);
    }
    const embedLink = `https://www.youtube.com/embed/${videoId}${url.search}`;
    return embedLink;
  }

  useEffect(() => {
    fetch();
  }, [isNewSectionCreated, isSectionDeleted, isSectionsOrderUpdated]);

  const handleCreate = async () => {
    let videoUrl = "";
    if (sectionData.videoUrl.trim() !== "") {
      videoUrl = convertYouTubeLink(sectionData.videoUrl);
    }

    let data = {
      title: sectionData.title,
      description: sectionData.description,
      videoUrl: videoUrl,
      pdfs: sectionData.pdfs,
    };

    console.log("data", data);

    const response = await createSection(data, moduleId);
    console.log("response", response);
    setIsNewSectionCreated(!isNewSectionCreated);
    setSectionCreateModalOpen(false);
  };

  if (!isLoading) {
    return (
      <DragDropContext onDragEnd={moveSection}>
        <div className="bg-white min-h-screen p-4">
          {/* Top Back Button */}
          <div className="flex justify-start mb-4">
            <Link to={`${url}/courses/${courseId}/modules/create`}>
              <Button
                variant="contained"
                startIcon={<FastRewindIcon />}
              >
                Back
              </Button>
            </Link>
          </div>

          {/* Create  Section */}

          <div className="flex justify-center px-2">
            <div className="w-full md:w-4/5 shadow-lg rounded overflow-hidden bg-white">
              <div className="px-4 py-4 border-b flex flex-row items-start md:items-center md:justify-between gap-4">
                <h2 className="font-bold text-xl">Create New Section</h2>

                <button
                  className="bg-blue-500 hover:bg-blue-400 text-white font-semibold py-2 px-4 rounded transition"
                  onClick={() => setSectionCreateModalOpen(true)}
                >
                  Create Section
                </button>

                <Dialog
                  open={sectionCreateModalOpen}
                  onClose={() => setSectionCreateModalOpen(false)}
                  fullWidth
                  maxWidth="md"
                  fullScreen={fullScreen}
                  scroll="paper"
                >
                  <DialogTitle>Section Form</DialogTitle>

                  <DialogContent dividers>
                    <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2, 'padding-top': 2 }}>
                      {/* Section Title */}
                      <TextField
                        label="Section Title"
                        name="title"
                        value={sectionData.title}
                        onChange={handleChange}
                        fullWidth
                      />
                      {isMobile ? (
                        <div className="text-center p-4 border rounded bg-yellow-50 text-yellow-800">
                          ⚠️ The text editor is not supported on small screens. <br />
                          Please use a desktop or tablet for editing.
                        </div>
                      ) : (
                        <Box sx={{ maxHeight: 250, overflowY: 'auto', width: '100%' }}>
                          <ReactQuill
                            value={sectionData.description}
                            onChange={(value) =>
                              setSectionData({ ...sectionData, description: value })
                            }
                            modules={modules}
                            formats={formats}
                            style={{ height: '160px', overflow: 'hidden' }}
                          />
                        </Box>
                      )}

                      {/* Video URL */}
                      <TextField
                        label="Video URL"
                        name="videoUrl"
                        value={sectionData.videoUrl}
                        onChange={handleChange}
                        fullWidth
                      />

                      {/* YouTube Guide */}
                      <Box className="bg-gray-50 p-4 rounded text-sm">
                        <h3 className="font-semibold mb-2">How to add YouTube video URL</h3>
                        <ol className="list-decimal space-y-2 pl-5">
                          <li>
                            Go to{' '}
                            <a
                              href="https://youtube.com"
                              className="text-blue-500 underline"
                              target="_blank"
                              rel="noreferrer"
                            >
                              YouTube
                            </a>
                          </li>
                          <li>
                            Share → Embed → Copy the <code>src</code> link <br />
                            Example: <code>https://www.youtube.com/embed/XXXXXXXX</code>
                          </li>
                          <li>Paste it into the field above.</li>
                        </ol>
                      </Box>

                      {/* PDF Upload */}
                      <input
                        accept="application/pdf"
                        type="file"
                        multiple
                        onChange={handleFileChange}
                      />

                      {/* Uploaded PDFs */}
                      {sectionData.pdfs.length > 0 && (
                        <List dense>
                          {sectionData.pdfs.map((pdf, index) => (
                            <ListItem key={index} divider>
                              <ListItemText primary={pdf.name} />
                              <Button onClick={() => handleRemovePDF(index)}>Remove</Button>
                            </ListItem>
                          ))}
                        </List>
                      )}
                    </Box>
                  </DialogContent>

                  <DialogActions>
                    <Button onClick={handleCreate} variant="contained" color="primary">
                      Create
                    </Button>
                    <Button onClick={() => setSectionCreateModalOpen(false)} variant="outlined">
                      Close
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* <Modal
                  open={sectionCreateModalOpen}
                  onClose={() => {
                    setSectionCreateModalOpen(false);
                  }}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                  className="rounded-lg"
                >
                  <Container sx={style} maxWidth="md">
                    <Typography variant="h4" gutterBottom>
                      Section Form
                    </Typography>
                    <Box component="form">
                      <TextField
                        label="Section Title"
                        name="title"
                        value={sectionData.title}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                      />
                  
                      <ReactQuill
                        value={sectionData.description}
                        onChange={(value) =>
                          setSectionData({ ...sectionData, description: value })
                        }
                        modules={modules}
                        formats={formats}
                      />
                      <TextField
                        label="Video URL"
                        name="videoUrl"
                        value={sectionData.videoUrl}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                      />
                      <div class=" mx-auto bg-white p-6 rounded-md shadow-md">
                        <h3>How to add youtube video URL</h3>
                        <ol class="list-decimal space-y-4">
                          <li>
                            Visit{" "}
                            <a
                              href="https://www.youtube.com/"
                              class="text-blue-500"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Youtube
                            </a>
                          </li>
                          <li class="pl-4">
                            Go to a video
                            <ul class="list-disc pl-6">
                              <li>Click on "Share"</li>
                              <li>
                                Click on "Embed" and simply copy the content
                                within the src attribute.
                              </li>
                              <li>
                                {" "}
                                For example, if the embed code contains:
                                src="https://www.youtube.com/embed/VMvBkuKOAgM?si=G6CXwWz0dn4z4q1y"
                              </li>
                              <li>
                                Just Copy the part :
                                https://www.youtube.com/embed/VMvBkuKOAgM?si=G6CXwWz0dn4z4q1y
                              </li>
                              <li>
                                Copy the link of this format: "https://www.youtube.com/embed/XXXXXXXX"
                              </li>
                            </ul>
                          </li>
                          <li>Put the link in the Video Url</li>
                        </ol>
                      </div>

                      <input
                        accept="application/pdf"
                        type="file"
                        multiple
                        onChange={handleFileChange}
                      />
                      {sectionData.pdfs.length > 0 && (
                        <List>
                          {sectionData.pdfs.map((pdf, index) => (
                            <ListItem key={index}>
                              <ListItemText primary={pdf.name} />
                              <Button onClick={() => handleRemovePDF(index)}>
                                Remove
                              </Button>
                            </ListItem>
                          ))}
                        </List>
                      )}
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleCreate}
                      >
                        Create
                      </Button>
                      <Button
                        style={{ marginLeft: "5px" }}
                        variant="contained"
                        onClick={() => setSectionCreateModalOpen(false)}
                      >
                        Close
                      </Button>
                    </Box>
                  </Container>
                </Modal> */}
              </div>
            </div>
          </div>
          {/* Create Section */}

          {/* Display sections */}
          <div className="mt-10 flex flex-col items-center">
            <h2 className="text-2xl font-bold mb-4">View Sections</h2>
            <Droppable droppableId="sections" direction="vertical">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps} className="w-full ">
                  {sections && sections.map((section, index) => (
                    <SectionCard
                      key={section._id}
                      section={section}
                      index={index}
                      handleDeleteButtonClick={handleDeleteButtonClick}
                      url={url}
                      courseId={courseId}
                      moduleId={moduleId}
                      handleSectionDelete={handleSectionDelete}
                      sectionDeleteModalOpen={sectionDeleteModalOpen}
                      setSectionDeleteModalOpen={setSectionDeleteModalOpen}
                    />
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>

            <div className="flex justify-end w-full md:w-4/5 mt-4">
              {/* <Button variant="contained" color="success" onClick={handleUpdateSectionsOrder}>
              Save Sections Order
            </Button> */}
              <button
                className="bg-green-500 hover:bg-green-400 text-white font-bold py-2 px-4  rounded"
                onClick={handleUpdateSectionsOrder}
              >
                Save Sections Order
              </button>
            </div>
          </div>
          {/* Display sections */}
          <div className="flex justify-start mt-8">
            <Link to={`${url}/courses/${courseId}/modules/create`}>
              <Button
                variant="contained"
                startIcon={<FastRewindIcon />}
              >
                Back
              </Button>
            </Link>
          </div>
        </div>
      </DragDropContext>
    );
  } else {
    return <Loader />;
  }
}
